var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('Card',{attrs:{"title":"Permissões"}},[_c('table',{staticClass:"table table-sm table-hover table-striped"},[_c('thead',[_c('tr',[_c('PkHeader'),_c('EditHeader'),_c('th',{attrs:{"data-column-id":"description","data-order":"asc","data-sortable":"true"}},[_vm._v("Descrição ")])],1)])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }